<template>    
    <BaseModal
        :id="'static-update'"
        :title="title"
        :size="''"
    >
        <template v-slot:breadcrumb>
            <Breadcrumb :breadcrumb="breadcrumb"/>
        </template>
        <template v-slot:content>
            <form class="col-12 p-0" @submit.prevent="form_submit_update(single_object.id, global_index)">
                <FormDynamic
                    :form_format="form_format"
                    :form_data="single_object"
                    :array_options="array_options"
                    :for_update="true"
                />
                <div class="row m-0">
                    <label v-html="`Additional Unassigned WorkSheet`" class="modal-label col-12" for=""/>
                </div>
                <span v-for="(val,index) in single_object.discharge_worksheets" :key="index" class="row m-0 formdynamic justify-content-md-between">
                    <span  class="p-0 formdynamic__item col-md-6">
                        <div class="formdynamic__item__field">
                            <label v-html="`Minutes`" class="modal-label "/>
                            <input 
                                :disabled="false"
                                :type="'number'" 
                                :class="''"            
                                v-model="single_object.discharge_worksheets[index].minutes"
                            />
                        </div>
                    </span>
                    <span  class="p-0 formdynamic__item col-md-6">
                        <div class="formdynamic__item__field">
                            <label v-html="`Decription Of Work`" class="modal-label "/>
                            <input 
                                :disabled="false"
                                :type="'text'" 
                                :class="''"             
                                v-model="single_object.discharge_worksheets[index].description"
                            />
                        </div>
                    </span>
                </span>
                <div class="row m-0">
                    <a v-html="`Add More`" href="#" class="d-inline-md-block col-12 text-right" @click="add_more()"></a>
                </div>
                 <span class="row m-0 formdynamic justify-content-md-between">
                    <span  class="p-0 formdynamic__item col-md-6">
                        <div class="formdynamic__item__field">
                            <label v-html="`Associate Signature`" class="modal-label"/>
                            <input 
                                :disabled="false"
                                :type="'text'" 
                                :class="''"            
                                v-model="single_object.associate_signature"
                            />
                        </div>
                    </span>
                </span>
                <CentralButtons :type="''" v-if="single_object.associate_signature === null"/>
            </form>
        </template>
    </BaseModal>
</template>

<script>

import FormResources    from    './form_resources'
import FormDynamic      from    '@/components/FormDynamic.vue'
import Breadcrumb       from    '@/components/BreadcrumbComponent/Breadcrumb'
import BaseModal        from    '@/components/BaseModal'
import CentralButtons   from    '@/components/CentralButtons'

export default {

    name:   'UpdateModal',
    props: [
        'title',
        'content_header',
        'rest_api',
        'notifications',
        'notyf',
        'axios',
        'single_object',
        'global_index',
        "array_options",
        "breadcrumb",
    ],

    components:{
        FormDynamic,
        Breadcrumb,
        BaseModal,
        CentralButtons,
    },

    data(){
        return{
            form_format:    FormResources.form_format,
        }
    },
    
    methods:{
        add_more() {
            this.single_object.discharge_worksheets.push({
                minutes:        '',
                description:    ''
            });
        }
    },

    mounted(){

    }
    
}
</script>